import React, { useState, useEffect } from 'react';
import api from '../services/api';
import '../styles/Admin.css';

const Admin = () => {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [usersResp, rolesResp, clientsResp] = await Promise.all([
        api.getPendingUsers(),
        api.getRoles(),
        api.getClients(),
      ]);

      setPendingUsers(usersResp.data || []);
      setRoles(rolesResp.data || []);
      setClients(clientsResp.data?.clients || clientsResp.data || []);
      setError('');
    } catch (err) {
      setError('Failed to load data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (userId, roleId, clientId = null) => {
    try {
      await api.approveUser(userId, { role_id: roleId, client_id: clientId });
      setSuccess('User approved successfully');
      setTimeout(() => setSuccess(''), 3000);
      loadData();
    } catch (err) {
      setError('Failed to approve user');
    }
  };

  return (
    <div className="content-container">
      <div className="page-header-section">
        <h2 className="section-title">Admin Panel - User Approvals</h2>
        <button onClick={loadData} className="btn btn-secondary">
          Refresh
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      {loading ? (
        <div className="loading">Loading pending users...</div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Registered At</th>
                <th>Assign Role</th>
                <th>Assign Client (Optional)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pendingUsers.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center' }}>
                    No pending approvals
                  </td>
                </tr>
              ) : (
                pendingUsers.map((user) => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.email}</td>
                    <td>{new Date(user.created_at).toLocaleDateString()}</td>
                    <td>
                      <select
                        id={`role-${user.id}`}
                        className="form-control"
                        defaultValue=""
                      >
                        <option value="">Select Role</option>
                        {roles.map((role) => (
                          <option key={role.id} value={role.id}>
                            {role.name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select
                        id={`client-${user.id}`}
                        className="form-control"
                        defaultValue=""
                      >
                        <option value="">None</option>
                        {clients.map((client) => (
                          <option key={client.client_id} value={client.client_id}>
                            {client.name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <button
                        onClick={() => {
                          const roleId = document.getElementById(`role-${user.id}`).value;
                          const clientId = document.getElementById(`client-${user.id}`).value;
                          if (!roleId) {
                            alert('Please select a role');
                            return;
                          }
                          handleApprove(user.id, roleId, clientId || null);
                        }}
                        className="btn btn-sm btn-primary"
                      >
                        Approve
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Admin;

